/**
 * Revenue Recognition Types
 * Display-only models (not form fields, calculated on the fly)
 */

export interface RevenueRecognitionPeriod {
  id: string
  periodLabel: string
  periodStartDate: Date
  periodEndDate: Date
  systemAmount: number
  systemPercentage: number
  statusCode: string
}

export interface RevenueRecognitionSchedule {
  periods: RevenueRecognitionPeriod[]
  totalSystemAmount: number
  totalSystemPercentage: number
}

// Calculation method constants for revenue recognition
export const REVENUE_RECOGNITION_METHOD = {
  STRAIGHT_LINE: 'straight-line',
  WEIGHTED: 'weighted',
} as const

export type RevenueRecognitionMethod = typeof REVENUE_RECOGNITION_METHOD[keyof typeof REVENUE_RECOGNITION_METHOD]

export const DEFAULT_REVENUE_RECOGNITION_METHOD: RevenueRecognitionMethod = REVENUE_RECOGNITION_METHOD.STRAIGHT_LINE

